import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ClientLayout from '../../layouts/client/ClientLayout';
import SingleOrderPage from '../../pages/clients/SingleOrderPage/SingleOrderPage';
import LoginPage from '../../pages/common/LoginPage/LoginPage';
import { useSelector } from 'react-redux';
import PaymentPage from '../../pages/clients/PaymentPage/PaymentPage';
import OrdersListPage from '../../pages/clients/OrdersListPage/OrdersListPage';
import ProfilePage from '../../pages/clients/ProfilePage/ProfilePage';
import PaymentConfirmationPage from '../../pages/clients/PaymentConfirmationPage/PaymentConfirmationPage';
import TokenLoginPage from '../../pages/common/TokenLoginPage/TokenLoginPage';
import AdminSetPassword from '../../pages/admin/AdminSetPassword/AdminSetPassword';
import UseTermsPage from '../../pages/common/UseTermsPage/UseTermsPage';
import SupportPage from '../../pages/common/SupportPage/SupportPage';

const ClientRoutes = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  return(
    <ClientLayout>
      <Routes>
        <Route path="/token" element={<TokenLoginPage />} />
        <Route path="/terms" element={<UseTermsPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/admin/token" element={<AdminSetPassword />} />
        {
          !isAuthenticated ?
          <>
            <Route path="/admin/login" element={<LoginPage />} />
            <Route path="/*" element={<LoginPage />} />
          </>
          :
          <>
            <Route path="/" element={<SingleOrderPage />} />
            <Route path="/pedido/:number" element={<SingleOrderPage />} />
            <Route path="/pedido/pagamento" element={<PaymentPage />} />
            <Route path="/pedidos" element={<OrdersListPage />} />
            <Route path="/perfil" element={<ProfilePage />} />
            <Route path="/pedido/pagamento/:number" element={<PaymentPage />} />
            <Route path="/pedido/resultado/:id" element={<PaymentConfirmationPage />} />
          </>
        }

      </Routes>
    </ClientLayout>
  ) 
};

export default ClientRoutes;
